import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
} from "@mui/material";
import { useEffect } from "react";
import logoutmodel from "../assets/logoutmodel.svg";
import CustomText, { textStyles } from "./CustomText";
import CustomButton from "./CustomButton";
import { useTranslation } from "react-i18next";
const LogoutModal = ({ open, loading = false, onConfirm, onClose }) => {
  const handleClose = () => {
    if (!loading) onClose?.();
  };
 const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      disableEscapeKeyDown={loading}
      PaperProps={{
        sx: {
          borderRadius: 3,
          textAlign: "center",
          p: 2,
          py:1,
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: "blur(1px)" },
      }}
    >
      <DialogContent sx={{ pt: 3 }}>
        {/* Top icon */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <img
            src={logoutmodel}
            alt="logout"
            style={{ width: 50, height: 50 }}
          />
        </Box>



        {/* Message */}
        <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 500,lineHeight:"32px" ,color: "#2C384C" }}>
           {t("logoutModel.message")}
        </CustomText>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 1.5,
          pb: 2.5,
          pt: 0,
        }}
      >
        {/* Cancel Button */}
        <CustomButton
          onClick={handleClose}
          disabled={loading}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
             {t("logoutModel.cancel")}
            </Box>
          }
          sx={{color:"#172B4D",backgroundColor:"white",
              "&:hover": {
      backgroundColor: "white",  // same as normal
      color: "#172B4D",          // same as normal
    },
          }}
        />

        {/* Logout Button */}
        <CustomButton
          onClick={onConfirm}
          disabled={loading}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {loading && (
                <CircularProgress
                  size={18}
                  thickness={4}
                  sx={{ color: "#ffffff" }}
                />
              )}
         {t("logoutModel.cta")}
            </Box>
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default LogoutModal;

